import React from "react";
import "./LandingPage.css";
import logo from "../assets/logo.png";
import atom from "../assets/edited atom.png";

const LandingPage: React.FC = () => {
  return (
    <div className="landing-container">
      <img src={atom} alt="Atom" className="top-right-atom" />

      <div className="overlay">
        <img src={logo} alt="Logo" className="center-logo" />

        <div className="title">
          <span className="line1">
            Risk<sup style={{ fontSize: "0.4em", top: "-0.4em", position: "relative" }}>3</sup>
          </span>
          <span className="line2">Qube</span>
        </div>

        <p className="tagline">Master the Risk. Own the Reward</p>
      </div>
    </div>
  );
};

export default LandingPage;
